import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  Nature,
  NatureDescription,
  Source,
  Status,
  Type,
} from '@shared/models';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  private http: HttpClient = inject(HttpClient);
  public natures!: Nature[];
  public types!: Type[];
  public sources!: Source[];
  public status!: Status[];

  public getNatures(): Observable<Nature[]> {
    return this.http
      .get<Nature[]>(`${environment.api.root}/Natures`)
      .pipe(tap((response) => (this.natures = response)));
  }

  public getTypes(): Observable<Type[]> {
    return this.http
      .get<Type[]>(`${environment.api.root}/Types`)
      .pipe(tap((response) => (this.types = response)));
  }

  public getSources(): Observable<Source[]> {
    return this.http
      .get<Source[]>(`${environment.api.root}/Sources`)
      .pipe(tap((response: Source[]) => (this.sources = response)));
  }

  public getStatus(): Observable<Status[]> {
    return this.http
      .get<Status[]>(`${environment.api.root}/Status`)
      .pipe(tap((response: Status[]) => (this.status = response)));
  }

  public getDescriptionByNature(
    natureId: string
  ): Observable<NatureDescription[]> {
    return this.http.get<NatureDescription[]>(
      `${environment.api.root}/Descriptions/${natureId}`
    );
  }
}
